goog.provide("shadow.js.shim.module$src$svg$wpp$content_actions$redo_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content_actions$redo_svg");
shadow.js.shim.module$src$svg$wpp$content_actions$redo_svg = shadow.js.nativeProvides["src/svg/wpp/content-actions/redo.svg"] = shadow$bridge("src/svg/wpp/content-actions/redo.svg");
module$shadow_js_shim_module$src$svg$wpp$content_actions$redo_svg.default = shadow.js.shim.module$src$svg$wpp$content_actions$redo_svg;
